import { cfg } from "../../config";
import dotenv from "dotenv";

dotenv.config();

export async function updateScore(clicker) {
  try {
    const difficulty = document.getElementById("difficulty-selected").dataset
      .value;
    const app = new Realm.App({ id: `${process.env.REALM_WEB_ID}` });
    const response = await fetch(
      `${process.env.HOST}/${cfg.API.routes.puzzle}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: app.currentUser.id,
          difficulty: {
            [difficulty]: {
              score: clicker,
            },
          },
        }),
      }
    );
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, data: error };
  }
}
